import { render, staticRenderFns } from "./headerXn.vue?vue&type=template&id=1d34ebbc&scoped=true&"
import script from "./headerXn.vue?vue&type=script&lang=js&"
export * from "./headerXn.vue?vue&type=script&lang=js&"
import style0 from "./headerXn.vue?vue&type=style&index=0&id=1d34ebbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d34ebbc",
  null
  
)

export default component.exports